import { Injectable } from '@angular/core';

import * as _ from 'underscore';

import { IBetSelection } from '../../../betslip/services/betSelection/bet-selection.model';
import { IBetSlipObject, IQuickbetSelectionModel } from '../../models/quickbet-selection.model';
import { PubSubService } from '../communication/pubsub/pubsub.service';
import { SessionStorageService } from '../storage/session-storage.service';
import { StorageService } from '../storage/storage.service';

export interface IEmptySelectionWithPrice {
    price: {
        priceType: string;
    };
}

@Injectable({ providedIn: 'root' })
export class BetslipSelectionsDataService {
    private selections: IBetSelection[];
    private quickbetSelection: IQuickbetSelectionModel | null;

    constructor(
        private pubsubService: PubSubService,
        private storageService: StorageService,
        protected sessionStorage: SessionStorageService,
    ) {
        this.selections = this.storageService.get('betSelections') || [];
    }

    subscribe(): void {
        this.pubsubService.subscribe('betSlipSelectionsData', this.pubsubService.API.BETSLIP_SELECTIONS_UPDATE, (...args: IBetSelection[]) => {
            this.selections = args;
        });

        this.pubsubService.subscribe('betSlipSelectionsData', this.pubsubService.API.QUICKBET_OPENED, (qbSelection: IQuickbetSelectionModel) => {
            this.quickbetSelection = qbSelection;
        });

        this.pubsubService.subscribe('betSlipSelectionsData', this.pubsubService.API.QUICKBET_PANEL_CLOSE, () => {
            this.quickbetSelection = null;
        });
    }

    /**
     * Returns selections count that are in the betSlip module
     * @returns {Number}
     */
    count(): number {
        return this.selections.length;
    }

    /**
     * Returns boolean value that corresponds is selection in betSlip
     * @param {string[]} outcomeIds
     * @param {string[]} qbOutcomeIds
     * @returns {boolean}
     */
    contains(outcomeIds: string[], qbOutcomeIds: string[]): boolean {
        let isInBetslipSelections = false;
        const isInQuickbetSelection =
            // @ts-ignore
            this.quickbetSelection?.outcomeId &&
            _.every(qbOutcomeIds, (outcomeId: string) => this.quickbetSelection?.outcomeId?.indexOf(outcomeId) !== -1);

        _.each(this.selections, (selection: IBetSelection) => {
            if (
                // @ts-ignore
                (selection.params?.id && _.every(outcomeIds, (outcomeId) => selection.params.id.indexOf(outcomeId) !== -1)) ||
                _.every(outcomeIds, (outcomeId: string) => (<string>selection.id).indexOf(outcomeId) !== -1)
            ) {
                isInBetslipSelections = true;
            }
        });
        // @ts-ignore
        return (isInBetslipSelections ?? false) || (isInQuickbetSelection ?? false);
    }

    /*
     * Get quickbet selection object
     * @returns {object}
     * */
    getQuickbetSelection(): IQuickbetSelectionModel {
        return this.quickbetSelection as IQuickbetSelectionModel;
    }

    /**
     * Returns selection by id from betSlip selections
     * @param outcomeId
     * @returns {Array.<T>}
     */
    getSelectionsByOutcomeId(outcomeId: string): (IBetSelection | IEmptySelectionWithPrice)[] {
        const betslipSelections = this.selections.filter((selection: IBetSelection) => {
            const outcomes = selection.outcomesIds || _.pluck(selection.outcomes || [], 'id');
            return outcomes.length === 1 && outcomes.includes(outcomeId);
        });

        if (betslipSelections.length) {
            return betslipSelections;
        }

        const quickbetSelection = this.quickbetSelection && this.quickbetSelection.outcomeId === outcomeId;

        if (quickbetSelection) {
            return [
                {
                    price: {
                        priceType: this.quickbetSelection?.price?.priceType ?? 'SP',
                    },
                },
            ];
        }

        return [];
    }

    /*
     * Add seelctions to betlsip
     * */
    addToBetslip(addToBetSlipObjects: any, fromPopularBetsOrAccas: any): void {
        let betSlipObjects = [];

        if (this.sessionStorage.get('QUICK_BET_OPENED')) {
            const quickbetSelectionData = this.sessionStorage.get('RemoteBS');
            if (quickbetSelectionData && quickbetSelectionData.selectionData) {
                let quickBetSelectionInPopularBetOrAcca = [];
                if (fromPopularBetsOrAccas) {
                    const quickBetSelectionId = [quickbetSelectionData.selectionData.outcomes[0].id];
                    quickBetSelectionInPopularBetOrAcca = addToBetSlipObjects.filter((item: IBetSlipObject) =>
                        quickBetSelectionId.includes(item.outcomes[0].id),
                    );
                }

                if (quickBetSelectionInPopularBetOrAcca.length > 0) {
                    betSlipObjects = addToBetSlipObjects;
                } else {
                    betSlipObjects = [quickbetSelectionData.selectionData, ...addToBetSlipObjects];
                    betSlipObjects.forEach((ele) => {
                        ele.isQBAlreadyOpened = true;
                        ele.goToBetslip = false;
                    });
                }
                this.sessionStorage.remove('QUICK_BET_OPENED');
                fromPopularBetsOrAccas && this.sessionStorage.remove('isAddAllToBetslipBarClicked');
            }
        } else {
            if (fromPopularBetsOrAccas) {
                betSlipObjects = addToBetSlipObjects;
            } else {
                betSlipObjects.push(addToBetSlipObjects[0]);
            }
        }
        this.pubsubService.publish(this.pubsubService.API.ADD_TO_BETSLIP_BY_SELECTION, [betSlipObjects]);
    }
}
